import React from "react";

import { useTheme } from "styled-components";

import EditableInput from "../../inline-edit/EditableInput";
import EditableText from "../../inline-edit/EditableText";
import ArrowRight from "../../../../../../../../../features/cards-v2/components/actions/icons/ArrowRight";
import {
  CardArrowContainer,
  CardContainer,
  CardContent,
  CardContentContainer,
  CardCover,
  CardCoverContainer,
  CardHeading,
  CardLabel,
  CardParagraph,
} from "./styles";
import { CARDS_PROP } from "../../../../../../settings/features/cards/defaults";

const ImageOne = ({ data, config, isEditable }) => {
  const theme = useTheme();

  return (
    <CardContainer
      imageUrl={data.image.link}
      borderRadius={config.borderRadius}
    >
      <CardCoverContainer>
        <CardCover
          imageUrl={data.image.link}
          borderRadius={config.borderRadius}
          position={data.image.focalPoint}
        />
      </CardCoverContainer>
      <CardContentContainer>
        <CardContent>
          <CardHeading>
            {isEditable ? (
              <EditableText
                inputProp={CARDS_PROP.TITLE}
                data={data}
                config={config}
                customCalculatorStyles={{ minHeight: "1em" }}
              />
            ) : (
              data.title
            )}
          </CardHeading>
          {config.layout.includes(CARDS_PROP.TEXT) && (
            <CardParagraph>
              {isEditable ? (
                <EditableText
                  inputProp={CARDS_PROP.TEXT}
                  data={data}
                  config={config}
                />
              ) : (
                data.text
              )}
            </CardParagraph>
          )}
        </CardContent>
        {config.layout.includes(CARDS_PROP.LABEL) && (
          <CardLabel
            background={data[CARDS_PROP.COLORS].accent[theme.name]}
            color={data[CARDS_PROP.COLORS].text[theme.name]}
          >
            {isEditable ? (
              <EditableInput
                inputProp={CARDS_PROP.LABEL}
                data={data}
                config={config}
                customStyles={{ textAlign: "center" }}
              />
            ) : (
              data.label
            )}
          </CardLabel>
        )}
      </CardContentContainer>
      {config.layout.includes(CARDS_PROP.ARROW) && (
        <CardArrowContainer>
          <ArrowRight fillColor="#FFF" />
        </CardArrowContainer>
      )}
    </CardContainer>
  );
};

export default ImageOne;
